import React from 'react';
import Lottie from 'react-lottie';
import { useLoader } from '@context/Utils';
import LoaderAnimation from './loading_EDEKA.json';
import './index.scss';

export function Loader() {
  // Constants
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LoaderAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  // Contexts
  const { loader } = useLoader();

  if (!loader) {
    return <></>;
  }

  return (
  <div
    id="loader"
    role="status"
    aria-live="polite"
    aria-atomic="true"
    aria-busy={loader}
  >
    <div className="lottie-container">
      <Lottie options={defaultOptions} />
    </div>
  </div>
);

}

export default Loader;
